module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fc-Hc-Ic-Ja.8140f23c.png";